/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { ICustomFieldFilter, ITPFilter } from 'src/app/app-data/models/TPFilterPredicates';
import { IAttachment } from '../../../app-data/models/Attachment';

export interface FilterFormCriteria {
	description?: ITPFilter;
	fromDate?: string;
	toDate?: string;
	locationIds?: string[];
	roleIds?: string[];
	externalScheduleId?: ITPFilter;
	type?: string[];
	wbsCode?: ITPFilter;
	attachment?: AttachmentFilterOptions;
	ticketStatus?: string[];
	customField1?: ICustomFieldFilter;
	customField2?: ICustomFieldFilter;
	customField3?: ICustomFieldFilter;
	ticketAttachments?: TicketAttachmentOptions;
	swimlaneIds?: string[];
	attachmentComment?: ITPFilter;
}

export type TicketValue = string | number | boolean | string[] | null;

export interface ITicketCustomFields {
	[key: string]: { customFieldId: string; value: TicketValue }[];
}

export enum FilterOperator {
	AND = 'AND',
	OR = 'OR',
}

export enum AttachmentFilterOptions {
	Any = 'Any',
	WithAttachments = 'WithAttachments',
	WithoutAttachments = 'WithoutAttachments',
}

export enum TicketStatusOptions {
	Completed = 'Completed',
	Started = 'Started',
	Todo = 'Todo',
}

export enum TicketAttachmentOptions {
	Any = 'Any',
	WithAttachments = 'WithAttachments',
	WithoutAttachments = 'WithoutAttachments',
}

export interface IPlanTicketsAttachments {
	[key: string]: IAttachment[];
}
